<template>
    <AppDropdown
        :id="componentId"
        :data="statuses"
        @select="setStatus"
        :disabled="disabled"
        :align="dropdownAlign"
        :stopPropagation="stopPropagation"
        :search="{ show: true, property: 'name', caseSensitive: false }">

        <template v-slot:menu-button>

            <!-- default -->
            <slot name="menu-button">
                <div class="btn btn-sm border rounded pl-3 pr-3">
                    <span v-if="isLoading" class="text-muted">LOADING</span>
                    <div v-else class="row m-0" style="height: 21px">
                        <template v-if="status.name">
                            <div :style="{ background: status.color }"
                                 class="align-self-center status-colored-rect">
                            </div>
                            <div v-if="withRightCaption" class="align-self-center ml-2">
                                {{ status.name }}
                            </div>
                        </template>
                        <div v-else-if="withRightCaption" class="text-muted">
                            Status
                        </div>
                    </div>
                </div>
            </slot>

        </template>

        <template #item="{ item }">
            <div :class="{'cannot-set-manually': !item.canSetManually }">
                <span :style="{ color: item.color }">
                    <i class="fas fa-square-full pr-1"></i>
                </span>
                <span :class="{ 'text-bold': status.uuid === item.uuid }">
                    {{ item.name }}
                </span>
            </div>
        </template>

    </AppDropdown>
</template>

<script>
import {showInfoMessage} from '@/services/snackbar'

export default {
    name: 'AppSetStatus',
    props: {
        componentId: {
            type: String,
            default: () => 'status-' + Math.random()
        },
        uuid: { // current status uuid
            required: true
        },
        statuses: {
            required: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        stopPropagation: {
            type: Boolean,
            default: false
        },
        dropdownAlign: {
            type: String,
            default: 'left'
        },
        showUnassigned: {
            type: Boolean,
            default: true
        },
        withRightCaption: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        status() {
            return this.statuses.find(s => s.uuid === this.uuid) || {}
        }
    },
    methods: {
        setStatus(status) {
            if (!status.canSetManually) {
                showInfoMessage('This status cannot be set manually.')
                return
            }
            this.$emit('change', status)
        }
    }
}
</script>

<style lang="scss" scoped>
.status-colored-rect {
    width: 14px;
    height: 14px;
}

.cannot-set-manually {
    filter: opacity(0.4);
}
</style>
